/**
 * NovelSprig 品牌 - Member 页面配置
 */
import { memberCommonConfig } from './common'
import type { MemberPageConfig } from './types'

/**
 * NovelSprig 品牌特定主题配置
 */
export const theme = {
  userNameColor: '#1F2937',
  userIdColor: '#4B5563',
  // 头像边框色
  avatarBorder: '#D1FAE5',
  // 按钮背景色
  btnPrimaryBg: '#D1FAE5',
  // Top Up 按钮背景色
  topUpBtnBg: 'linear-gradient(90deg, #10B981 0%, #059669 100%)',
  // VIP 背景图 URL
  vipSubscribeBg: 'linear-gradient(135deg, #D1FAE5 0%, #ECFDF5 100%)',
} as const

/**
 * NovelSprig 品牌特定资源配置
 */
export const resources = {
  // 页面背景图
  memberBg: '/images/novelsprig/member-bg.svg',
  // 用户背景图
  userBg: '/images/novelsprig/user-bg.svg',
  // 用户默认头像
  userDefaultAvatar: '/images/novelsprig/user-default.svg',
  // VIP 图标
  memberVip: '/images/novelsprig/reader-vip.svg',
  // VIP 折扣图标
  memberVipDiscount: '/images/novelsprig/reader-vip.svg',
} as const

export const memberConfig: MemberPageConfig = {
  showLoginBtn: false,
  theme,
  resources,
  menuIcons: {
    transaction: '/images/novelsprig/member/icon-transaction.svg',
    unlocked: '/images/novelsprig/member/icon-unlock.svg',
    contactUs: '/images/novelsprig/member/icon-contact.svg',
    setting: '/images/novelsprig/member/icon-setting.svg',
  },
  texts: memberCommonConfig.texts,
}
